export const DATA_SET = 'featureFlagInfo.DATA_SET';
